import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  DeleteAiToneOfVoiceMutation,
  DeleteAiToneOfVoiceMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const deleteAiToneOfVoice = graphql(`
  mutation deleteAiToneOfVoice($id: String!) {
    deleteAiToneOfVoice(id: $id) {
      id
      label
      rawValue
      isDefault
    }
  }
`);

export function useDeleteAiToneOfVoice(
  options?: UseMutationOptions<
    DeleteAiToneOfVoiceMutation,
    unknown,
    DeleteAiToneOfVoiceMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(deleteAiToneOfVoice, {
    ...options,
    onSuccess: async (data, variables, context) => {
      options?.onSuccess?.(data, variables, context);

      await queryClient.invalidateQueries({ queryKey: ["aiToneOfVoices"] });
    },
  });

  return { data: data?.deleteAiToneOfVoice, ...rest };
}
